module.exports = __webpack_public_path__ + "img/3.296838f5.jpg";